<template>
  <v-container>
    <div class="mt-6 align-center">
      <v-card-actions class="justify-center">
      <h4>5 Year Exempt Manufacturing</h4>
     </v-card-actions >
      <v-row  align="center" >
        <v-col class="ml-4 " cols="4">
          <h4>Tax Record Info</h4>
        </v-col>
<v-col cols="3">
  <CommonDropDowns :isItTaxYear=true @change="dataFromCommonDropDowns"
  :criteriaState="criteriaState"/>
</v-col>
        <v-col class="ml-4" cols="4">
          <h4>Apportionment Details</h4>
        </v-col>
      </v-row>
    <v-row>
      <v-col cols="6">
        <CRUDList class="mt-10"
          :canAdd="false" :canEdit="false" :canSave="false"
          :showSelect="false" :enableFixedHeaders="false" :displayTopPagination="false"
          :headers="taxRecordsHeader"
          :baseCrudKey="taxRecordCrudKey"
          tableWrapperDynamicClassname='elevation-3 mt-n5 ma-3 pt-0 pa-1 taxroll-table-wrapper'
          tableDynamicClassname='taxroll-custom-table'
          tableDynamicHeight='200'
          dialogDynamicWidth='200'
          @loadCRUDList = "loadExemptTaxRecordsHandler"
          :footerTotalDisplayColumnWise="totalOfExemptTaxes"
          :defaultSortBy="defaultSortByForTax"
          :loadingData="gridLoading.flag"
          :loadingText="gridLoading.text"
        >
    </CRUDList>
    <v-row align="center" class="ma-0 pa-0 mt-n6">
     <v-col cols="3">
      <v-checkbox class="input-text-size"
      @change="checkShowDetailsForExempt"
      label="Show details" />
     </v-col>
     <v-col cols="4" >
      <v-checkbox class="input-text-size" v-model="checkTIFAdjustmentsFlag"
       label="TIF Adjustments" />
     </v-col>
      <v-col cols="4" class="ml-n6">
        <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" small @click="createApportDetails"
                :loading="isCreatingApportionDetails"
                :disabled='isExemptPaymentAvailable || isCreatingApportionDetails'>
                 Create Apportionment Details
                </v-btn>
              </template>
              <span>Create Apportionment Details</span>
            </v-tooltip>
      </v-col>
      <v-col cols="5" class="mt-n10">
        <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" small
                @click="updateExemptFromTaxInquiryHandler"
                :disabled='isExemptPaymentAvailable'>
                 Update records From Tax
                </v-btn>
              </template>
              <span> Update records from Tax Inquiry</span>
            </v-tooltip>
      </v-col>
      <v-col cols="4" class="mt-n10">
        <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" small
                :disabled=!isApportionmentAvailable
                 @click="printCollectionSummaryReport">
                 CS & tax District
                </v-btn>
              </template>
              <span>Print Collection Summary & Tax District Breakdown</span>
            </v-tooltip>
    </v-col>
    </v-row>
      </v-col>
      <v-col cols="6">
        <CRUDList class="mt-10"
    :canAdd="false" :canEdit="itemIsEditable" :canSave="true"
      :showSelect="false" :enableFixedHeaders="true" :displayTopPagination="false"
      :headers="apportionmentDetailsHeader"
      :baseCrudKey="apportionmentCrudKey"
      tableWrapperDynamicClassname='elevation-3 mt-n5 ma-3 pt-0 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      :defaultSortBy="defaultSortByForApportion"
      :footerTotalDisplayColumnWise="totalOfExemptApportionment"
       dialogHeaderName="Exempt Manufacturing Master Record"
       @upsertItem="upsertApporitonmentDetails"
      :selectedItems="selectedItems"
       @loadCRUDList = "loadExemptMfgApportionHanlder"
      tableDynamicHeight='200'
      dialogDynamicWidth='400'
      >
      <template v-slot:[`editedItem`]="{}">
          <ExemptMfgApportionmentDialog :baseCrudKey="apportionmentCrudKey" />
        </template>
    </CRUDList>
    <v-checkbox class="input-text-size ml-4" @change="checkShowDetailsForApportion"
    v-model="showDetailsForApportion" label="Show details" />
      </v-col>
    </v-row>
    <CRUDDialog
      ref="crudDialog"
      :canSave="false"
      :baseCrudKey="tifAdjustmentsDialogCrudKey"
      onlyDialogHeaderName="Tax Amount found in a TIF Base Tax District"
      dialogDynamicWidth='600'
    >
      <template v-slot:[`editedItem`]="{}">
        <slot name="editedItem">
          <v-container>
            <v-data-table
              :headers="tifAdjustmentsListHeaders"
              :items-per-page="100"
              :items="tifAdjustmentsList"
              class="hide-footer-select elevation-1 input-text-size"
              hide-default-footer
              fixed-header
              style="max-height: 500px; overflow-y: auto">
              <template v-slot:[`item.schoolDistrict`]="{ item }">
                <v-text-field v-model="item.schoolDistrict" readonly tabindex="-1"/>
              </template>
              <template v-slot:[`item.tifSchoolDistrict`]="{ item }">
                <v-text-field v-model="item.tifSchoolDistrict" readonly tabindex="-1"/>
              </template>
              <template v-slot:[`item.totalTaxSum`]="{ item }">
                <v-text-field v-model="item.totalTaxSum" readonly tabindex="-1"/>
              </template>
              <template v-slot:[`item.taxAmountInBase`]="{ item, index }">
                <v-text-field
                  v-model="item.taxAmountInBase"
                  @blur="roundAmount(item.taxAmountInBase, index)"
                  @focus="amountToNum(item.taxAmountInBase, index), $event.target.select()"
                  dense
                  class="input-text-size"
                >
                </v-text-field>
              </template>
            </v-data-table>
          </v-container>
        </slot>
      </template>
      <template v-slot:[`additionalActions`]="{}">
      <v-btn class="input-text-size" @click="confirmTIFAdjustments()" text color="blue darken-1"
        :loading="isConfirmingTifAdjustments" :disabled="isConfirmingTifAdjustments">
        Confirm
      </v-btn>
      </template>
    </CRUDDialog>
  </div>
  </v-container>
</template>
<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import '../../../assets/style.css';
import { clients } from '../../../util/clients';
import {
  amountFormat,
  amountToNumber,
  defaultGridLoading, manageGridLoading,
} from '../../../util/shared/vue-global';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { generateQueryString } from '../../common/base/report/report-util';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import { makeCriteriaStateNullIfEmptyString } from '../common-utils/CommonTaxFunctionalities';
import ExemptMfgApportionmentDialog from './ExemptMfgApportionmentDialog.vue';
import { taxRecordsHeader } from './ExemptMfgHeader.utils';

const { backendRest } = clients.direct;

export default {
  name: 'ExemptMfgList',
  data() {
    return {
      baseCrudKey: 'exemptMfgKey',
      taxRecordCrudKey: 'taxRecordCrudKey',
      apportionmentCrudKey: 'apportionmentCrudKey',
      exemptPaymentCrudKey: 'exemptPaymentCrudKey',
      taxRecordsHeader,
      gridLoading: defaultGridLoading(),
      showDetailsForApportion: false,
      combineCommonData: true,
      showDetailsForTaxRecord: false,
      totalOfExemptTaxes: [null, null, 'Total :', null, null, null, null, null, null],
      totalOfExemptApportionment: [null, null, null, null, null, null, '', '', '', ''],
      apportionmentDetailsHeader: [
        {
          text: 'Type',
          value: 'recordType',
          sortable: false,
        },
        {
          text: 'Year',
          value: 'taxYear',
          sortable: false,
        },
        {
          text: 'Tax Unit', value: 'taxUnit', sortable: false,
        },
        { text: 'Tax Fund', value: 'fundNumber', sortable: false },
        { text: 'Description', value: 'taxFundDescription', sortable: false },
        { text: 'Priority', value: 'priority', sortable: false },
        {
          text: 'Expected Amt', value: 'expectedAmount', align: 'right', formatter: 'amountCanbeBlank', sortable: false,
        },
        {
          text: 'Apport Amt', value: 'apportionmentAmount', align: 'right', formatter: 'amountCanbeBlank', sortable: false,
        },
        {
          text: 'Coll. Amount', value: 'collectedAmount', align: 'right', formatter: 'amountCanbeBlank', sortable: false,
        },
        {
          text: 'Uncoll. Amount', value: 'unCollectedAmount', align: 'right', formatter: 'amountCanbeBlank', sortable: false,
        },
        {
          text: 'Date', value: 'payDate', sortable: false,
        },
      ],
      checkTIFAdjustmentsFlag: false,
      isCreatingApportionDetails: false,
      isConfirmingTifAdjustments: false,
      tifAdjustmentsDialogCrudKey: 'tifAdjustmentsDialogCrudKey',
      tifAdjustmentsList: [],
      originalTotalTaxSums: [], // Store original totalTaxSum values
      tifAdjustmentsListHeaders: [
        { text: 'TIF Base Tax District', value: 'schoolDistrict' },
        { text: 'Tax Amount in Base', value: 'totalTaxSum' },
        { text: 'TIF Distribution Tax District', value: 'tifSchoolDistrict' },
        { text: 'Tax Amount in Transfer', value: 'taxAmountInBase' },
      ],
      // showFlaggedRecords: false,
    };
  },
  components: {
    CRUDList,
    CommonDropDowns,
    ExemptMfgApportionmentDialog,
    CRUDDialog,
  },

  created() {
    this.initializeAPI();
  },
  watch: {
    latestTaxYear: {
      handler(newVal, oldVal) {
        if (newVal && !oldVal) {
          this.criteriaState.taxYear = newVal;
          this.loadExemptTaxRecordsHandler();
          this.loadExemptMfgApportionSummaryHandler();
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria', 'items', 'item',
    ]),
    ...mapState({
      StoreSelItems: (state) => state.tax.taxExemptMfg.selectedItems,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
    }),

    editedItem: {
      get() {
        return this.item(this.apportionmentCrudKey);
      },
      set(value) {
        this.setItem([this.apportionmentCrudKey, value]);
      },
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    isExemptPaymentAvailable() {
      const items = this.items(this.exemptPaymentCrudKey);
      return items.length > 0;
    },
    isApportionmentAvailable() {
      const items = this.items(this.apportionmentCrudKey);
      return items.length > 0;
    },
    itemIsEditable() {
      const item = this.item(this.apportionmentCrudKey);
      return (item.recordType === 'Original') && !this.isExemptPaymentAvailable;
    },
    appotionmentItems() {
      return this.items(this.apportionmentCrudKey);
    },

    criteriaState: {
      get() {
        return this.criteria(this.taxRecordCrudKey);
      },
      set(value) {
        this.setCriteria([this.taxRecordCrudKey, value]);
      },
    },
    criteriaStateForAppotion: {
      get() {
        return this.criteria(this.apportionmentCrudKey);
      },
      set(value) {
        this.setCriteria([this.apportionmentCrudKey, value]);
      },
    },

    defaultSortByForApportion() {
      return [
        {
          column: 'priority',
          direction: 'asc',
        },
      ];
    },
    defaultSortByForTax() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
      ];
    },
  },

  methods: {
    amountFormat,
    manageGridLoading,
    ...mapMutations('base/crud', [
      'setCriteria', 'setItems', 'setIsVisible', 'setItem',
    ]),
    ...mapActions(['reAuth', 'flashError', 'flashWarn', 'flashSuccess']),
    ...mapActions('tax/taxExemptMfg', [
      'updateExemptFromTaxInquiry', 'createExemptMfgApportion', 'upsertTaxExempt', 'loadExemptMfgApportion', 'loadExemptTax', 'loadExemptTaxPayment', 'exemptTaxesTotal',
      'getExemptApportionmentTotal', 'getExemptBasedOnTif', 'createTifExemptMfgApportion', 'setSelectedItems', 'loadExemptMfgApportionSummary',
    ]),
    initializeAPI() {
      this.loadExemptTaxPaymentHandler();
      // this.loadExemptMfgApportionHanlder();
    },
    async loadExemptTaxPaymentHandler() {
      const criteria = {
        taxYear: this.criteriaState.taxYear,
      };
      this.loadExemptTaxPayment({ criteria, baseCrudKey: this.exemptPaymentCrudKey });
    },

    async loadExemptMfgApportionHanlder() {
      const criteria = {
        needPaymentData: this.showDetailsForApportion,
        needToMerge: this.combineCommonData,
        ...this.criteriaStateForAppotion,
        taxYear: this.criteriaState.taxYear,
      };
      await this.loadExemptMfgApportion({ criteria, baseCrudKey: this.apportionmentCrudKey });
      await this.getExemptApportionmentTotalHandler();
    },

    async getExemptApportionmentTotalHandler() {
      const criteria = {
        needPaymentData: this.showDetailsForApportion,
        taxYear: this.criteriaState.taxYear,
        ...this.criteriaStateForAppotion,
      };
      const totals = await this.getExemptApportionmentTotal({ criteria });
      this.totalOfExemptApportionment = [
        null, null, null, null, null, null,
        amountFormat(totals.expectedAmount),
        amountFormat(totals.apportionmentAmount),
        amountFormat(totals.collectedAmount),
        amountFormat(totals.unCollectedAmount),
      ];
    },

    async exemptTaxTotalHandler() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      const criteria = {
        ...this.criteriaState,

      };
      const totals = await this.exemptTaxesTotal({
        criteria,
        baseCrudKey: this.taxRecordCrudKey,
      });
      this.totalOfExemptTaxes = [null, null, 'Total',
        amountFormat(totals.totalTax), null,
        amountFormat(totals.totalPaid), amountFormat(totals.totalDue)];
    },

    async loadExemptTaxRecordsHandler() {
      manageGridLoading(this, true, 'Searching...');
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      const criteria = { ...returnCriteria };
      await this.loadExemptTax({
        criteria,
        baseCrudKey: this.taxRecordCrudKey,
      });
      await this.exemptTaxTotalHandler();
      manageGridLoading(this, false);
    },
    async updateExemptFromTaxInquiryHandler() {
      manageGridLoading(this, true, 'Searching...');
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      const criteria = {
        ...this.criteriaState,

      };
      await this.updateExemptFromTaxInquiry({
        criteria,
        baseCrudKey: this.taxRecordCrudKey,
      });
      await this.exemptTaxTotalHandler();
      manageGridLoading(this, false);
    },
    async  dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      await this.loadExemptTaxRecordsHandler();
      this.loadExemptTaxPaymentHandler();
      await this.commonApiCall();
      await this.exemptTaxTotalHandler();
      await this.getExemptApportionmentTotalHandler();
      // Call the footer summary handler when taxYear changes
      if (whichField === 'taxYear') {
        await this.loadExemptMfgApportionSummaryHandler();
      }
      // const criteria= {
      //   taxYear: this.criteriaState.taxYear,
      // }
      //  await this.loadExemptMfgApportion({ criteria, baseCrudKey: this.apportionmentCrudKey });
      // await this.getExemptApportionmentTotalHandler();
    },
    async checkShowDetailsForExempt(val) {
      if (val === false) {
        // this.setItems([this.taxRecordCrudKey, []]);
        // await this.loadExemptTaxRecordsHandler();
      } else {
        const items = this.items(this.taxRecordCrudKey) || [];
        const tempArr = [];
        for (const item of items) {
          tempArr.push({
            type: 'original',
            ...item,
          });

          const payments = item.taxPayments || [];
          for (const payItem of payments) {
            const totalPaid = ((payItem.taxDetails && payItem.taxDetails[0]) || {}).taxAmt || 0;

            tempArr.push({
              type: 'payment',
              payDate: payItem.payDate || '',
              totalPaid,
            });
          }
        }

        // this.setItems([this.taxRecordCrudKey, tempArr]);
      }
    },
    async checkShowDetailsForApportion(val) {
      // eslint-disable-next-line no-unused-expressions, no-self-compare
      this.showDetailsForApportion !== this.showDetailsForApportion;
      if (val) {
        this.apportionmentDetailsHeader[5].sortable = false;
      } else {
        this.apportionmentDetailsHeader[5].sortable = true;
      }
      await this.loadExemptMfgApportionHanlder();
    },
    async upsertApporitonmentDetails(item) {
      const updatedItem = { ...item };
      delete updatedItem.recordType;
      delete updatedItem.apportionmentDetails;
      const keys = ['expectedAmount', 'collectedAmount', 'unCollectedAmount'];
      keys.forEach((key) => {
        if (updatedItem[key]) {
          updatedItem[key] = amountToNumber(updatedItem[key]);
        }
      });
      await this.upsertTaxExempt({
        item: updatedItem,
        baseCrudKey: this.taxRecordCrudKey,
      });
      await this.loadExemptMfgApportionHanlder();
    },
    async createApportDetails() {
      if (this.isCreatingApportionDetails) return;
      const items = this.items(this.taxRecordCrudKey);
      if (items.length < 1) {
        this.flashWarn('There is no record available in Tax Record Info');
        return;
      }

      this.isCreatingApportionDetails = true;
      try {
        if (!this.checkTIFAdjustmentsFlag) {
          const criteria = {
            taxYear: this.criteriaState.taxYear,
          };
          await this.createExemptMfgApportion({ criteria, baseCrudKey: this.apportionmentCrudKey });
          await this.commonApiCall();
        } else {
          const tifAdjustments = await this.getExemptBasedOnTif({
            criteria: { taxYear: this.criteriaState.taxYear || this.latestTaxYear },
          });
          if ((tifAdjustments || []).length) {
            this.tifAdjustmentsList = tifAdjustments.map((item) => ({
              ...item,
              totalTaxSum: amountFormat(item.totalTaxSum),
            }));
            // Store original totalTaxSum values for calculations
            this.originalTotalTaxSums = tifAdjustments.map((item) => item.totalTaxSum);
            this.setIsVisible([this.tifAdjustmentsDialogCrudKey, true]);
          } else {
            // this.setIsVisible([this.tifAdjustmentsDialogCrudKey, false]);
            // await this.commonApiCall();
            this.flashWarn('There is no TIF adjustment available');
          }
        }
      } finally {
        this.isCreatingApportionDetails = false;
      }
    },
    async commonApiCall() {
      const criteria = {
        ...this.criteriaStateForAppotion,
      };
      if (this.criteriaState.taxYear) {
        criteria.taxYear = this.criteriaState.taxYear;
      }
      // await this.createExemptMfgApportion({ criteria, baseCrudKey: this.apportionmentCrudKey });
      await this.loadExemptMfgApportionHanlder().finally(() => {
        manageGridLoading(this, false);
      });
    },
    async confirmTIFAdjustments() {
      if (this.isConfirmingTifAdjustments) return;
      const tifAdjustmentsFormatter = [];
      for (let i = 0; i < this.tifAdjustmentsList.length; i += 1) {
        const item = this.tifAdjustmentsList[i];
        const taxAmountInBase = amountToNumber(item.taxAmountInBase);
        const totalTaxSum = amountToNumber(item.totalTaxSum);
        // if (taxAmountInBase) {
        tifAdjustmentsFormatter.push({
          schoolDistrict: item.schoolDistrict,
          tifSchoolDistrict: item.tifSchoolDistrict,
          taxAmtDifference: totalTaxSum - taxAmountInBase,
          taxAmountInBase,
          totalTaxSum,
        });
        // }
      }
      // const criteria = {
      // };
      // if (this.criteriaState.taxYear) {
      //   criteria.taxYear = this.criteriaState.taxYear;
      // }
      this.isConfirmingTifAdjustments = true;
      try {
        const res = await this.createTifExemptMfgApportion({
          item: {
            taxYear: this.criteriaState.taxYear,
            upsertData: tifAdjustmentsFormatter,
          },
        });
        if (res.statusCode === 200) {
          this.setIsVisible([this.tifAdjustmentsDialogCrudKey, false]);
          await this.commonApiCall();
          this.flashSuccess('TIF Adjustments updated successfully');
        } else {
          this.flashError('There was a problem while upserting the tif base district in exempt mfg!');
        }
      } finally {
        this.isConfirmingTifAdjustments = false;
      }
    },
    roundAmount(val, index) {
      const curItem = this.tifAdjustmentsList[index];
      const formattedTaxAmountInBase = amountFormat(amountToNumber(val));
      curItem.taxAmountInBase = formattedTaxAmountInBase;

      // Update totalTaxSum by subtracting taxAmountInBase from original totalTaxSum
      const originalTotal = this.originalTotalTaxSums[index] || 0;
      const taxAmountInBaseNum = amountToNumber(formattedTaxAmountInBase);
      const updatedTotalTaxSum = originalTotal - taxAmountInBaseNum;
      curItem.totalTaxSum = amountFormat(updatedTotalTaxSum);
    },
    amountToNum(val, index) {
      const curItem = this.tifAdjustmentsList[index];
      curItem.taxAmountInBase = amountToNumber(val);

      // Update totalTaxSum by subtracting taxAmountInBase from original totalTaxSum
      const originalTotal = this.originalTotalTaxSums[index] || 0;
      const taxAmountInBaseNum = amountToNumber(val);
      const updatedTotalTaxSum = originalTotal - taxAmountInBaseNum;
      curItem.totalTaxSum = amountFormat(updatedTotalTaxSum);
    },
    async getParamsData() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const params = [];
      params.push(`token=${jwt}`);
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      params.push(`filters=${encodedCriteria}`);
      return params;
    },
    async printCollectionSummaryReport() {
      const params = await this.getParamsData();
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/exempt-mfg/collection-summary${queryString}`;
      const breakdownUrl = `${backendRest.defaults.baseURL}/exempt-mfg/tax-district-breakdown${queryString}`;
      window.open(url, '_blank');
      window.open(breakdownUrl, '_blank');
    },
    async loadExemptMfgApportionSummaryHandler() {
      // Guard against timing issues - ensure taxYear exists
      if (!this.criteriaState.taxYear) {
        return;
      }

      const criteria = {
        needPaymentData: true,
        ...this.criteriaStateForAppotion,
        taxYear: this.criteriaState.taxYear,
      };
      await this.loadExemptMfgApportionSummary({ criteria, baseCrudKey: 'exemptMfgSummaryKey' });
    },
  },

};
</script>
<style scoped>
</style>
